export const FAILED_TOKEN_MESSAGE = 'Failed to get token';
